export default __webpack_public_path__ + "media/images/dog-2-ba164ce94865582dccfef83d61b5c6b7.svg";